var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialMediaSymbol({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "social-media-feed__social-symbol",
    width: 195,
    height: 356,
    viewBox: "0 0 195 356",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.1892 134.378C117.728 134.378 134.378 117.728 134.378 97.1892C134.378 76.6502 117.728 60 97.1891 60C76.6502 60 60 76.6502 60 97.1892C60 117.728 76.6502 134.378 97.1892 134.378ZM1.06867e-05 97.1892C1.65888e-05 150.865 43.5131 194.378 97.1892 194.378C150.865 194.378 194.378 150.865 194.378 97.1892C194.378 43.5131 150.865 -1.32998e-06 97.1891 4.57211e-06C43.5131 1.04742e-05 4.78459e-06 43.5131 1.06867e-05 97.1892Z",
    fill: "#4F0CBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3832 194.378L190.238 355.856L4.22565 355.856L97.3832 194.378Z",
    fill: "#96D73B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaSymbol);
export default __webpack_public_path__ + "static/media/social-media-symbol.f7f1291b.svg";
export { ForwardRef as ReactComponent };